import type { FaireProductEntity } from "../../entity_types/product";

export const p_av8bwntabe: FaireProductEntity = {
  token: "p_av8bwntabe",
  type: "product",
  name: "Beachball Organic Iced Tea (Variety Pack)- Case of 12",
  brandToken: "b_6029b89p",
  brandName: "Sail Away Coffee Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/15b39d58921b4fc2e09bc0f97de4ddd75c4fceb60e17b142c60c3e400a312b0d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fef51feba957f8a597f9290a0d0cf8b3fbfc1c9cb1de99dbba7ece09c00e59ae.png",
    "https://cdn.faire.com/fastly/d7bfeb1da456934c47bd01749ada1e6bca4cad8a65494f580a348633c80a773d.png",
    "https://cdn.faire.com/fastly/c04a7467edd30875c8cb1895904b5ef2df8074356394b349e4d6b72548cbfd62.png",
    "https://cdn.faire.com/fastly/853c388417e8130206d48500406b28fb540e4be125282fed4e4d8ae34f305ad0.png",
  ],
  priceDollars: 2.95,
  description:
    "Discover the Refreshing Taste of Beachball Organic Iced Tea 🌊✨\n\nBeachball is redefining organic iced tea with bold flavors and fresh, organic ingredients.\n\nEach sip delivers a crisp, naturally brewed taste—crafted from premium tea leaves and real fruit flavors, with only 4 grams of sugar per can for a guilt-free indulgence. Beachball brings you a low-sugar, better-for-you refreshment without compromise.\n\n🌱 Certified Organic Ingredients\n💧 Real Brewed Tea \n🍯 Low Sugar – Just 4g Per Can\n🎉 3 Flavors, 1x Case of Each\n\nSip the organic, low-sugar revolution & let Beachball transport you to pure refreshment. Your taste buds will thank you! 🌊🍹\n\n\norganic iced tea cans - real tea ",
  tags: [],
  msrpDollars: 5.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:05.096Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
